var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "final-docs" },
    [
      _c("Collapse", { staticClass: "final-docs__collaspe" }, [
        _c(
          "div",
          {
            staticClass: "final-docs__collaspe-title-box",
            attrs: { slot: "title" },
            slot: "title",
          },
          [
            _c(
              "span",
              { staticClass: "final-docs__collaspe-title default-title" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tenantProjects.finalDocuments.title")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "final-docs__collaspe-subtitle",
                on: {
                  click: function () {
                    return _vm.$refs.checkListModal.open()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "tenantProjects.finalDocuments.submissionChecklist"
                      )
                    ) +
                    "\n        "
                ),
                _c("i", { staticClass: "fa fa-question-circle" }),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "final-docs__collaspe-group float-right" },
              [
                _vm.isCompletedFinalDoc
                  ? _c("span", { staticClass: "final-docs__collaspe-status" }, [
                      _c("i", {
                        staticClass:
                          "final-docs__collaspe-status_check fa fa-check",
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("tenantProjects.final-docs.completed", [
                              _vm.$options.filters["formatDate"](
                                _vm.completedHistory.createdAt,
                                "DD MMM YYYY"
                              ),
                            ])
                          ) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "final-docs__collaspe-content",
            attrs: { slot: "content" },
            slot: "content",
          },
          [
            _c("div", { staticClass: "row final-docs__bar" }, [
              _c(
                "div",
                { staticClass: "small-8" },
                [!_vm.isHistorical ? _c("ExemptCheckBox") : _vm._e()],
                1
              ),
              _vm._v(" "),
              _vm.isHKlandUser || _vm.folders.length
                ? _c(
                    "div",
                    { staticClass: "small-4" },
                    [
                      _vm.isHKlandUser
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "final-docs__btns row align-right",
                              },
                              [
                                _vm.showReminderButton
                                  ? _c("HKLButton", {
                                      attrs: {
                                        color: "darkblue",
                                        action: "sendReminder",
                                      },
                                      on: {
                                        click: function () {
                                          return _vm.openReminderModal()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showCompleteButton
                                  ? _c("HKLButton", {
                                      attrs: {
                                        color: "darkblue",
                                        action: "complete",
                                      },
                                      on: { click: _vm.openCompleteModal },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isFolderFlow && _vm.showAddFolderButton
                                  ? [
                                      _c("AddFolder", {
                                        attrs: {
                                          color: "orange",
                                          action: "addFolder",
                                        },
                                        on: {
                                          click: function () {
                                            return _vm.openCompleteModal()
                                          },
                                          change: function () {
                                            return _vm.fetchFolders()
                                          },
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.folders.length
                        ? _c(
                            "div",
                            { staticClass: "final-docs__btns row align-right" },
                            [
                              _c("HKLButton", {
                                attrs: {
                                  color: "orange",
                                  action: _vm.isCollapseAll
                                    ? "expandAll"
                                    : "collapseAll",
                                },
                                on: {
                                  click: function () {
                                    return _vm.isCollapseAll
                                      ? _vm.expandAll()
                                      : _vm.collapseAll()
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.isFolderFlow
              ? _c(
                  "div",
                  { staticClass: "folder-group" },
                  [
                    _vm.folders.length === 0
                      ? [
                          _c(
                            "HKLViewLayout",
                            { attrs: { checkIsTenant: true } },
                            [
                              _c("div", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "tenantProjects.final-docs.noFolders"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.folders.length > 0
                      ? [
                          _vm._l(_vm.folders, function (folder, index) {
                            return _c(
                              "Collapse",
                              {
                                key: folder.id,
                                ref: "collapseRefs",
                                refInFor: true,
                                attrs: {
                                  id: _vm.folderCollapseId(folder.id),
                                  expand: !folder.isAccepted,
                                },
                                on: {
                                  "expand-status": _vm.onFolderExpandStatus,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "folder-title-wrapper",
                                    attrs: { slot: "title" },
                                    slot: "title",
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "default-title" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(folder.folderName) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        folder.isAfterEnd
                                          ? _c(
                                              "span",
                                              { staticClass: "after-hint" },
                                              [
                                                _vm._v(
                                                  "\n                   " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "tenantProjects.final-docs.addedAfterEnd"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        folder.canDeleteFolder
                                          ? _c(
                                              "DottedDropdown",
                                              {
                                                attrs: {
                                                  id: "folder-" + index,
                                                },
                                              },
                                              [
                                                folder.canDeleteFolder
                                                  ? _c("li", [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dot-option-btn",
                                                          on: {
                                                            click: function () {
                                                              return _vm.openDeleteModal(
                                                                folder.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "action.delete"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    folder.showBadge
                                      ? _c("HKLStatusBadge", {
                                          staticClass: "cursor-pointer",
                                          attrs: {
                                            value: _vm._f("uppercase")(
                                              _vm.$t(
                                                folder.status.toLowerCase()
                                              )
                                            ),
                                            color: folder.isRejected
                                              ? "red"
                                              : "light-green",
                                          },
                                          on: {
                                            click: function () {
                                              return _vm.lifecycleModalOpen(
                                                index
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("template", { slot: "additional" }, [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.showFolderDescriptionTeaser(
                                              folder
                                            ),
                                          expression:
                                            "showFolderDescriptionTeaser(folder)",
                                        },
                                      ],
                                      staticClass: "folder-description-teaser",
                                      class: {
                                        "folder-description-teaser--last":
                                          index === _vm.folders.length - 1,
                                      },
                                    },
                                    [
                                      _c(
                                        "pre",
                                        {
                                          staticClass:
                                            "folder-description-teaser__text",
                                          class: {
                                            "folder-description-teaser__text--newline":
                                              _vm.hasFolderDescriptionNewline(
                                                folder
                                              ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.folderDescriptionDisplay(
                                                folder
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "final-docs__collaspe-content",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("HKLPencilTextarea", {
                                      attrs: {
                                        canEdit:
                                          folder.canEditFolderDescription &&
                                          _vm.isFolderExpanded(folder.id),
                                        value: folder.description,
                                        defaultHint:
                                          _vm.isHKlandUser &&
                                          folder.canEditFolderDescription
                                            ? _vm.$t(
                                                "project.docs.fillDescHint"
                                              )
                                            : "",
                                      },
                                      on: {
                                        close: function (newVal) {
                                          return _vm.updateFolder(folder.id, {
                                            description: newVal,
                                          })
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    folder.canUploadFiles
                                      ? _c("HkldDropzone", {
                                          attrs: {
                                            sourceId: folder.docsSrcId,
                                            metaData: { uploadOnTop: true },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("EditAttachments", {
                                      attrs: {
                                        sourceId: folder.docsSrcId,
                                        canDownloadAll: _vm.isHKlandUser,
                                        canDelete: folder.canDeleteFile,
                                        showAllDeleteBtn: false,
                                        uploadOnTop: true,
                                        canEdit: folder.canEditFile,
                                        showDeleteBtnFunc: _vm.canDel,
                                        getFilesList: function (files) {
                                          return _vm.setFolderFiles(
                                            index,
                                            files
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          folder.canEditFolderDescription &&
                                          !_vm.isFinalDocEnd
                                            ? {
                                                key: "buttons",
                                                fn: function () {
                                                  return [
                                                    _c("HKLButton", {
                                                      attrs: {
                                                        color: "darkblue",
                                                        action: "rejectAction",
                                                      },
                                                      on: {
                                                        click: function () {
                                                          return _vm.rejectModalOpen(
                                                            folder.id
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("HKLButton", {
                                                      attrs: {
                                                        color: "orange",
                                                        action: "accept",
                                                      },
                                                      on: {
                                                        click: function () {
                                                          return _vm.acceptFolder(
                                                            folder.id
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _vm.canDeleteFolder
                            ? _c("HKLModal", {
                                ref: "deleteModalRef",
                                attrs: {
                                  okBtnAction: "delete",
                                  title: _vm.$t(
                                    "tenantProjects.final-docs.deleteModalHint"
                                  ),
                                },
                                on: {
                                  onOkClick: function () {
                                    return _vm.deleteFolder()
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "HKLModal",
                            {
                              ref: "rejectModal",
                              attrs: {
                                okBtnAction: "rejectAction",
                                title: _vm.$t(
                                  "tenantProjects.greenFitOut.rejectAlert"
                                ),
                                beforeOkClick: _vm.formValidate,
                              },
                              on: {
                                onOkClick: function () {
                                  return _vm.rejectFolder()
                                },
                              },
                            },
                            [
                              _c(
                                "HKLForm",
                                { ref: "formRef", staticClass: "text-input" },
                                [
                                  _c("HKLTextarea", {
                                    directives: [
                                      {
                                        name: "fusioninputcheck",
                                        rawName: "v-fusioninputcheck",
                                        value: {
                                          type: "string",
                                          required: true,
                                        },
                                        expression:
                                          "{\n                  type: 'string',\n                  required: true\n                }",
                                      },
                                    ],
                                    model: {
                                      value: _vm.rejectReason,
                                      callback: function ($$v) {
                                        _vm.rejectReason = $$v
                                      },
                                      expression: "rejectReason",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "HKLModal",
                            {
                              ref: "lifecycleModal",
                              attrs: {
                                hasCancelBtn: false,
                                closeable: true,
                                size: "large",
                                title: _vm.$t("history"),
                              },
                            },
                            [
                              _c("HKLTable", {
                                staticClass: "lifecycle",
                                attrs: {
                                  dataSource: _vm.lifecycleHistories,
                                  columns: _vm.lifecycleColumns,
                                  sort: "updatedAt",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sourceId && !_vm.isFolderFlow
              ? [
                  _vm.canUpload
                    ? _c("HkldDropzone", {
                        attrs: {
                          sourceId: _vm.sourceId,
                          metaData: { uploadOnTop: true },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("EditAttachments", {
                    ref: "editAttachments",
                    attrs: {
                      sourceId: _vm.sourceId,
                      canDownloadAll: false,
                      canDelete: true,
                      showAllDeleteBtn: false,
                      getFilesList: _vm.getFilesList,
                      uploadOnTop: true,
                      canEdit: _vm.canEdit,
                      showDeleteBtnFunc: _vm.canDel,
                    },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("History"),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("SendReminderModal", { ref: "sendReminderModal" }),
      _vm._v(" "),
      _c("SubmissionChecklist", { ref: "checkListModal" }),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "completeModalRef",
        attrs: {
          okBtnAction: "yesComplete",
          cancelBtnAction: "goback",
          title: _vm.$t("tenantProjects.final-docs.completeHint"),
        },
        on: { onOkClick: _vm.complete },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }